import { render, staticRenderFns } from "./teste-bi-2.vue?vue&type=template&id=3f1ffa06"
import script from "./teste-bi-2.vue?vue&type=script&lang=js"
export * from "./teste-bi-2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports